export function uidNumber() {
  return Date.now() + Math.floor(Math.random() * 100000);
}
